import React, { useState, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderselectapi } from "../../../../Components/Forms/renders";
import DateInput from "../../../../Components/Forms/date";
import mask from "../../../../Components/Forms/mask";
import MultiSelectData from "../../../../Components/Forms/multiselectdata";
import SwitcButton from "../../../../Components/Forms/switch";

const BedrijvenForm = ({ handleSubmit, bedrijven, initialValues, ervaringen }) => {
  const [einddatum, setEinddatum] = useState(false);
  const [openervaring, setOpenervaring] = useState(false);

  useEffect(() => {
    changerole(initialValues.role);
  }, [initialValues.role]);

  const checkrole = (val) => {
    changerole(val.target.value);
  };

  const changerole = (val) => {
    if (val === "manager" || val === "admin" || val === "hoofdrecreatie" || val === "havenmeester") {
      setEinddatum(false);
    } else if (val === "ervaringeigenaar") {
      setOpenervaring(true);
    } else {
      setEinddatum(true);
      setOpenervaring(false);
    }
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field name="email" type="input" validate={[required()]} component={renderField} label="Vul het e-mailadres in" />
              <Field name="voornaam" type="input" validate={[required()]} component={renderField} label="Vul de voornaam in" />
              <Field name="achternaam" type="input" validate={[required()]} component={renderField} label="Vul de achternaam in" />
              <Field name="telefoonnummer" type="input" mask="39999999999" validate={[required()]} component={mask} label="Vul je telefoonnummer in" />
              <Field name="bedrijf" type="input" validate={[required()]} component={renderselectapi} options={bedrijven} label="Vul het bedrijf in" />
              <Field
                name="role"
                type="input"
                validate={[required()]}
                component={renderselect}
                onChange={checkrole}
                options={{
                  manager: "Manager",
                  medewerker: "Medewerker",
                  bedrijfseigenaar: "Bedrijfseigenaar",
                  ervaringeigenaar: "Ervaringseigenaar",
                  havenmeester: "Havenmeester",
                  receptie: "receptie",
                  installateur: "Installateur",
                }}
                label="Vul de rol van de medewerker in"
              />

              {/* Account Status Actions */}
              <div className="row mt-3">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Account Status Acties</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <Field
                            name="isVerified"
                            component={SwitcButton}
                            label="E-mail Activeren"
                          />
                          <small className="form-text text-muted">
                            Activeer of deactiveer e-mail verificatie voor deze gebruiker.
                          </small>
                        </div>
                        <div className="col-md-6">
                          <Field
                            name="SmsAuth"
                            component={SwitcButton}
                            label="SMS Activeren"
                          />
                          <small className="form-text text-muted">
                            Activeer of deactiveer SMS authenticatie voor deze gebruiker.
                          </small>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <Field
                            name="blocked"
                            component={SwitcButton}
                            label="Account Blokkeren"
                          />
                          <small className="form-text text-muted">
                            Blokkeer of deblokkeer deze gebruiker.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2FA Requirement Toggle */}
              <div className="row mt-3">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Beveiliging</h5>
                    </div>
                    <div className="card-body">
                      <Field
                        name="require2FA"
                        component={SwitcButton}
                        label="2FA Verplicht"
                      />
                      <small className="form-text text-muted">
                        Wanneer ingeschakeld, moet deze gebruiker een SMS-verificatiecode invoeren bij het inloggen vanaf een nieuw IP-adres.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {einddatum && <Field name="einddatum" type="input" component={DateInput} label="Vul de einddatum in van het contract" />}
              {openervaring && <Field name="ervaringen" type="input" dataKey="_id" textField="naam" validate={[required()]} component={MultiSelectData} options={ervaringen} label="Vul het de ervaringen in" />}
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Updates" />
          </div>
        </div>
      </form>
    </div>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "gebruikers_edit", // a unique identifier for this form
})(BedrijvenForm);

const mapStateToProps = (state) => ({
  initialValues: state.gebruikers.item,
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
